export const PRICE_FORMAT_OPTIONS: Intl.NumberFormatOptions = { style: 'currency', currency: 'EUR' };
